import React from 'react';

export const backArrow = (
  <svg width="7" height="10" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.29.188A.703.703 0 0 0 5.807 0a.703.703 0 0 0-.482.188L.7 4.541a.622.622 0 0 0-.2.453c0 .17.072.334.2.454L5.326 9.8c.17.169.425.237.664.178a.662.662 0 0 0 .488-.46.617.617 0 0 0-.19-.625l-4.145-3.9 4.145-3.9c.128-.12.2-.282.2-.452A.622.622 0 0 0 6.29.188z"
      fill="#5D6771"
      fillRule="nonzero"
    />
  </svg>
);
